export default __webpack_public_path__ + "74ce01e0284bd8cb162be81b360469fd.png";